import defaultConfig from "../config.json"

interface Config {
  labelPrice: { min: number; max: number; price: number }[]
  cloudSubscription: number
  labelLifecycle: number
}

export const useConfig = (): Config => defaultConfig
